import requests from '../request'

const ids = 'userId=11111111&unitId=11111111'
// const apiUrl = process.env.NODE_ENV !== 'development' ? process.env.VUE_APP_TEMPLATE_BACK_URL : '/cas'

// export default {

//   casLogout (data) {
//     return requests({
//       url: 'hrm/sys/cas/client/logout',
//       method: 'POST',
//       data
//     })
//   },

//   listAuthAPI (params) {
//     return requests({
//       url: 'hrm/permission/user/listAuth?userId=' + params,
//       method: 'GET',
//       headers: {
//         'Contont-type': 'application/x-www-form-urlencoded'
//       }
//     })
//   }
// }

export const loginAPI = (data) => {
  return requests({
    url: '/api/system/baseUser/login',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
export const loginByTokenAPI = (data) => {
  return requests({
    url: '/api/system/baseUser/loginByToken',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
export const logoutAPI = (data) => {
  return requests({
    url: `/api/system/baseUser/logout?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
export const loginBytokenAPI = (data) => {
  return requests({
    url: `/api/system/baseUser/loginByToken`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
